// Overlay de carga a pantalla completa. Se crea una sola vez y se muestra/oculta.
const ID = "loading-overlay";

export const Loading = {
  mostrar() {
    let el = document.getElementById(ID);
    if (!el) {
      el = document.createElement("div");
      el.id = ID;
      el.className = "loading-overlay";
      el.innerHTML =
        '<div class="spinner-border text-light" role="status" style="width:3rem;height:3rem">' +
        '<span class="visually-hidden">Cargando...</span></div>';
      document.body.appendChild(el);
    }
    el.hidden = false;
  },

  ocultar() {
    const el = document.getElementById(ID);
    if (el) el.hidden = true;
  },
};
